import { FC } from 'react';

import { IIconProps } from '../types';

const SidebarControlIcon: FC<IIconProps> = ({ className }) => (
  <i className={`sidebar-control-icon icon ${className}`} />
);

export default SidebarControlIcon;
